/**
 * Centralized action type constants for pad-initialization feature.
 * Follows naming convention: feature/ACTION_NAME
 */

export const ACTION_TYPES = {
  // ---------------------------
  // General / Pad Data
  // ---------------------------
  FETCH_PAD_DATA: 'pad-initialization/FETCH_PAD_DATA',
  FETCH_PAD_VISIT_DATA: 'pad-initialization/FETCH_PAD_VISIT_DATA',
  SUBMIT_INITIALIZATION: 'pad-initialization/SUBMIT_INITIALIZATION',
  SET_INITIALIZATION_STEPS: 'pad-initialization/SET_INITIALIZATION_STEPS',
  RESET: 'pad-initialization/RESET',

  // ---------------------------
  // Schedule Prescriptions
  // ---------------------------
  UPDATE_SCHEDULE_PRESCRIPTION: 'pad-initialization/UPDATE_SCHEDULE_PRESCRIPTION',

  // ---------------------------
  // Hospital Release Prevision
  // ---------------------------
  SET_HOSPITAL_RELEASE_PREVISION: 'pad-initialization/SET_HOSPITAL_RELEASE_PREVISION',

  // ---------------------------
  // Discharge Patient
  // ---------------------------
  DISCHARGE_PATIENT: 'pad-initialization/DISCHARGE_PATIENT',

  // ---------------------------
  // Schedule Implantation
  // ---------------------------
  SET_SCHEDULE_IMPLANTATION: 'pad-initialization/SET_SCHEDULE_IMPLANTATION',

  // ---------------------------
  // Suspension Visits
  // ---------------------------
  SET_SUSPENSION_VISITS: 'pad-initialization/SET_SUSPENSION_VISITS',

  // ---------------------------
  // Calendar
  // ---------------------------
  FETCH_CALENDAR: 'pad-initialization/FETCH_CALENDAR',
  FETCH_CALENDAR_SEARCH: 'pad-initialization/FETCH_CALENDAR_SEARCH',
  RESET_CALENDAR: 'pad-initialization/RESET_CALENDAR',

  // ---------------------------
  // Schedule Visits
  // ---------------------------
  AUTOMATIC_REPETITION: 'pad-initialization/AUTOMATIC_REPETITION',
  DAILY_AUTOMATIC_REPETITION: 'pad-initialization/DAILY_AUTOMATIC_REPETITION',
  CLEAR_SCHEDULE: 'pad-initialization/CLEAR_SCHEDULE',
  DAILY_SCHEDULE_FORM_CHANGE: 'pad-initialization/DAILY_SCHEDULE_FORM_CHANGE',
  DAILY_SCHEDULE_FORM_ADD: 'pad-initialization/DAILY_SCHEDULE_FORM_ADD',
  SCHEDULE_MAXIMUM_VISITS: 'pad-initialization/SCHEDULE_MAXIMUM_VISITS',
  SELECT_AND_UPDATE_DATA: 'pad-initialization/SELECT_AND_UPDATE_DATA',
  APPLY_SELECTION_VISIT_PRESCRIPTION_SCHEDULE:
    'pad-initialization/APPLY_SELECTION_VISIT_PRESCRIPTION_SCHEDULE',
  LOAD_VISIT_PRESCRIPTION_SCHEDULE: 'pad-initialization/LOAD_VISIT_PRESCRIPTION_SCHEDULE',
  SET_CAN_STEP_FORWARD: 'pad-initialization/SET_CAN_STEP_FORWARD',
  // ---------------------------
  // Feedback
  // ---------------------------
  FEEDBACK_PENDING: 'pad-initialization/FEEDBACK_PENDING',
  FEEDBACK_SUCCESS: 'pad-initialization/FEEDBACK_SUCCESS',
  FEEDBACK_FAILURE: 'pad-initialization/FEEDBACK_FAILURE',
  FEEDBACK_CLEAR: 'pad-initialization/FEEDBACK_CLEAR'
};

// Async action suffixes
export const ASYNC_SUFFIXES = {
  PENDING: '_PENDING',
  FULFILLED: '_FULFILLED',
  REJECTED: '_REJECTED'
};

// Helper to get full async action type
export const getAsyncActionTypePending = baseType => `${baseType}_PENDING`;
export const getAsyncActionTypeReject = baseType => `${baseType}_REJECTED`;
export const getAsyncActionTypeFulfiled = baseType => `${baseType}_FULFILLED`;

export default ACTION_TYPES;
